module.exports = __webpack_public_path__ + "img/April.078104f8.png";